const _excluded = ["field", "form", "meta"],
  _excluded2 = ["errorMessage", "onDismiss"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { Field } from 'formik';
import { Dropdown } from 'office-ui-fabric-react';
import * as React from 'react';
import { createFakeEvent, getErrorMessage, invokeAll } from '../formikControlsUtils';
import { FormikErrorMessage } from '../ErrorMessage';

/**
 * Formik compatible wrapper for the Fabric UI Drop Down component.
 * Supports single select only. Use FormikMultiSelect for selecting more than one option.
 * See FormikDropDownProps for wiring information.
 * @param {FormikDatePickerProps} props
 * @returns A Date Picker component.
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const FormikMultiSelect = _ref => {
  let {
    name,
    label = 'Multi Select',
    selectedKeys = [],
    options,
    touched,
    errorMessage,
    required
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: name,
      label: label,
      selectedKeys: selectedKeys,
      component: FabricUiMultiSelectWrapper,
      options: options,
      required: required
    }), /*#__PURE__*/_jsx(FormikErrorMessage, {
      touched: touched,
      errorMessage: errorMessage
    })]
  });
};
function FabricUiMultiSelectWrapper(_ref2) {
  let {
      field,
      form,
      meta
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const _mapFieldToDropdown = mapFieldToDropdown({
      field,
      form,
      meta
    }),
    {
      errorMessage,
      onDismiss
    } = _mapFieldToDropdown,
    fieldProps = _objectWithoutProperties(_mapFieldToDropdown, _excluded2);
  return /*#__PURE__*/_jsx(Dropdown, _objectSpread(_objectSpread({}, props), {}, {
    multiSelect: true,
    onDismiss: invokeAll(onDismiss, props.onDismiss)
  }, fieldProps));
}
function mapFieldToDropdown(props) {
  const {
    form,
    field,
    meta
  } = props;
  const shared = {
    errorMessage: getErrorMessage({
      field,
      form,
      meta
    }),
    onDismiss: () => field.onBlur(createFakeEvent(field))
  };
  if (isArrayFieldProps(props)) {
    return mapFieldToMultiSelect(props, shared);
  } else {
    const propsWithValue = _objectSpread(_objectSpread({}, props), {}, {
      field: _objectSpread(_objectSpread({}, props.field), {}, {
        value: []
      })
    });
    return mapFieldToMultiSelect(propsWithValue, shared);
  }
}
function isArrayFieldProps(props) {
  const arrayFieldProps = props;
  const field = arrayFieldProps.field;
  return field.value !== undefined && field.value.length !== undefined;
}
function mapFieldToMultiSelect(_ref3, shared) {
  let {
    field,
    form
  } = _ref3;
  return _objectSpread(_objectSpread({}, shared), {}, {
    selectedKeys: field.value,
    onChange: (_, option) => {
      const value = field.value;
      const fieldName = field.name;
      if (option.selected) {
        form.setFieldValue(fieldName, [...value, option.key]);
      } else {
        const idx = field.value.indexOf(option.key);
        if (idx !== -1) {
          form.setFieldValue(fieldName, [...value.slice(0, idx), ...value.slice(idx + 1)]);
        }
      }
    }
  });
}